/* eslint-disable no-console */
/* eslint-disable require-jsdoc */
import ScrollMagic from 'scrollmagic';
import $ from 'jquery';
/**
 * Creates a Animation instance
 * @class
 */
export default class Animation {
  /**
   * Header
   * @param {object} $el - DOM element.
   */
  constructor( $el ) {
    this.$elements = $el;
    this.controller = null;
    this.scene = null;

    this.events();
  }

  init() {
    this.controller = new ScrollMagic.Controller();
    this.scene = [];

    this.$elements.each((index, element) => {
      this.animate( element );
    });

    setTimeout(() => {
      this.controller.addScene(this.scene);
    }, 100);
  }

  destroy() {
    if ( this.controller !== null ) {
      this.controller.destroy(true);
      this.controller = null;
      this.scene = null;
    }
  }

  reload() {
    this.destroy();
    this.init();
  }

  animate( element ) {
    const $el = $(element);
    
    this.scene.push( new ScrollMagic.Scene({
      triggerElement: element,
      triggerHook: 0.7
    }).on('enter', () => {
      if ( !$el.hasClass('animation--done') ) {
        $el.addClass('animation--done');
      }
    }));
  }
  
  events() {
    $(window).on('load', () => {
      this.reload();
    });
  }
}
